import { useState, useCallback } from 'react';
import * as groupManagementAction from "../redux/store-sarang/group/group-management.store";

export const useLookupGroup = () => {
    const [group, setGroup] = useState([]);

    const getLookupGroup = useCallback(async () => {
        try {
            const res = await groupManagementAction.GetLookupGroup();
            if (res && res.content) {
                setGroup(res.content);
                return res.content;
            }
            return [];
        } catch (err) {
            console.error(err);
            throw err;
        }
    }, []);

    return { group, getLookupGroup };
};
